import React from 'react';
import cx from 'clsx';

export const RichText: React.FC<React.HTMLProps<HTMLDivElement>> = ({ className = '', children, ...props }) => (
  <div
    className={cx(
      'select-auto leading-loose',
      'prose-headings:font-medium prose-headings:mb-4 prose-headings:mt-6',
      'prose-h1:text-3xl prose-h1:font-semibold',
      'prose-h2:text-2xl',
      'prose-h3:text-xl',
      'prose-h4:text-lg',
      'prose-strong:font-semibold',
      'prose-em:italic',
      'prose-p:text-base prose-p:mb-4',
      'prose-a:text-brand-default-500',
      className,
    )}
    {...props}
  >
    {children}
  </div>
);
